/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Toast_File_Downloaded_SuccessInputs */



/**
* | output |
* | --- |
* | "File downloaded successfully" |
*
* @param {Spaces_Toast_File_Downloaded_SuccessInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_toast_file_downloaded_success = /** @type {((inputs?: Spaces_Toast_File_Downloaded_SuccessInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Toast_File_Downloaded_SuccessInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Datei erfolgreich heruntergeladen")
	return /** @type {LocalizedString} */ ("File downloaded successfully")
});